import { dropEndpointIds } from 'root/src/shared/drops/drops.constants';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
import { authenticationTypes } from 'root/src/shared/constants/auth';
export const getAllDropsGamesEndpoint = {
    [dropEndpointIds.GET_ALL_DROPS_GAMES]: {
        authentication: authenticationTypes.unauthenticated,
        endpointType: otherEndpointType,
    },
};
